import Footer from "../../Common/footer";
import Header from "../../Common/header";
import MobileLab from "../../images/mobile_lab_1.webp";
import useDocumentTitle from "../../Common/useDocumentTitle";

/**
 * Returns the 404 Page Not Found component.
 * 
 * @returns The 404 Page Not Found component.
 */
const PageNotFound = () => {
    useDocumentTitle("404 Page Not Found");
    
    return (
        <>
            <Header />

            <main className="relative isolate min-h-full h-screen" style={{ maxHeight: "80vh" }}>
                <img
                    src={MobileLab}
                    alt=""
                    className="absolute inset-0 -z-10 h-full w-full object-cover object-center bg-blend-overlay opacity-70"
                />
                <div className="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
                    <p className="text-lg font-semibold leading-8 text-white">404</p>
                    <h1 className="mt-4 text-3xl font-bold tracking-tight text-white sm:text-5xl">Page not found</h1>
                    <p className="mt-4 text-base text-white sm:mt-6">Sorry, the page you are looking for doesn't exist.</p>
                    <div className="mt-10 flex justify-center">
                        <a href="/" className="text-base font-semibold leading-7 text-white">
                            <span aria-hidden="true">&larr;</span> Back to home
                        </a>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
};

export default PageNotFound;

/* ඞ */